import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    const full = `${title} · IMPEXMILTRADE GMBH`;
    document.title = full;
    const setMeta = (name, content, attr = "name") => {
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", full, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
  }, [title, description]);
  return null;
}
